import ReactDOM from "react-dom/client";
import React from "react";
import "./index.css";
import App from "./App";
import {SentryErrorBoundary} from "lib/sentry";
import {AppErrorBoundary} from "components/AppErrorBoundary";
import ErrorPage from "./pages/ErrorPage";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SentryErrorBoundary
      fallback={<ErrorPage />}
      showDialog // Enables Sentry's error reporting dialog
      dialogOptions={{
        title: "We encountered an error",
        subtitle: "Our team has been notified.",
        subtitle2: "Error ID: {% event_id %}",
      }}>
      <AppErrorBoundary captureSentry={false}>
        <App />
      </AppErrorBoundary>
    </SentryErrorBoundary>
  </React.StrictMode>,
);
